<div class="backspinner" *ngIf="mode === 'indeterminate'">
    <div class="spinner-border" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>